var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.333 2.583a.75.75 0 0 1 .75.75v4.656l.001.011-.001.01v4.656a.75.75 0 0 1-1.5 0V8.75H3.417v3.916a.75.75 0 0 1-1.5 0V3.333a.75.75 0 0 1 1.5 0V7.25h5.166V3.333a.75.75 0 0 1 .75-.75M11.917 6.709a.75.75 0 0 1 1.166.624v4.583h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h.25V8.704a.748.748 0 0 1-.666-1.328z"
  })));
};
export default Svg16;